export const fetchCrmEmailRecipientsExport = (request, { emailId, signal }) =>
  request({
    method: 'get',
    pathname: `/api/crm-email/export-recipients-csv/${emailId}`,
    signal,
    responseType: 'blob',
    notShowErrorMessage: true,
  });

export const fetchCrmEmailPerformanceExport = (request, { emailId, signal }) =>
  request({
    method: 'get',
    pathname: `/api/crm-email/export-performance-csv/${emailId}`,
    signal,
    responseType: 'blob',
    notShowErrorMessage: true,
  });
